import { IAlbumSales } from "../types/idol";

export const albumSales: IAlbumSales = {
  THEBOYZ: {
    "THE FIRST": {
      img: "https://i.ibb.co/vBwVBVr/theboyz-the-First.png",
      albumSalesData: [11100, 12700, 14200, 16000, 18700, 24000, 24100],
      mainColor: "#FAD502",
    },
    "THE SPHERE": {
      img: "https://i.ibb.co/7vdYGRD/theboyz-the-Sphere.png",
      albumSalesData: [8800, 10900, 14800, 19300, 21200, 22900, 23400],
      mainColor: "#D32230",
    },
    "THE ONLY": {
      img: "https://i.ibb.co/qBjnc8y/theboyz-the-Only.png",
      albumSalesData: [20800, 32400, 37700, 41600, 42600, 42900, 43400],
      mainColor: "#E0DFE2",
    },
    "Bloom Bloom": {
      img: "https://i.ibb.co/5vXJt4V/theboyz-bloom-Bloom.png",
      albumSalesData: [18100, 20300, 21600, 23600, 30100, 35200, 41100],
      mainColor: "#5093C7",
    },
    DREAMLIKE: {
      img: "https://i.ibb.co/bKCDcmm/theboyz-dream-Like.png",
      albumSalesData: [5300, 7000, 8000, 10000, 17500, 22100, 26200],
      mainColor: "#9EFAFF",
    },
    REVEAL: {
      img: "https://i.ibb.co/jZ8bpGh/theboyz-REVEAL.png",
      albumSalesData: [14800, 21800, 25000, 31200, 44400, 48500, 48500],
      mainColor: "#840D13",
    },
    CHASE: {
      img: "https://i.ibb.co/7jYRSKk/theboyz-chase.png",
      albumSalesData: [64600, 95600, 113500, 170800, 197600, 210300, 212600],
      mainColor: "#AF0009",
    },
    "THRILL-ING": {
      img: "https://i.ibb.co/chmxwcj/theboyz-thrill-ing.png",
      albumSalesData: [149300, 209900, 239100, 313600, 396700, 423000, 523600],
      mainColor: "#00ED53",
    },
    MAVERICK: {
      img: "https://i.ibb.co/k3t8r3n/theboyz-maverick.png",
      albumSalesData: [158900, 226000, 284400, 360200, 415000, 438600, 489600],
      mainColor: "#D22466",
    },
    "BE AWARE": {
      img: "https://i.ibb.co/Y7Wzh9Y/theboyz-be-Aware.png",
      albumSalesData: [99700, 193700, 284400, 352000, 373500, 382800, 496800],
      mainColor: "#FD8AFD",
    },
    "BE AWAKE": {
      img: "https://i.ibb.co/Tgb3QsZ/theboyz-be-Awake.png",
      albumSalesData: [78800, 229000, 309700, 338400, 369500, 378200, 415900],
      mainColor: "#F2FE81",
    },
    "PHANTASY Pt.1": {
      img: "https://i.ibb.co/M9XMs2C/theboyz-phantasy-pt1.png",
      albumSalesData: [106100, 173700, 231900, 270400, 302100, 304800, 333200],
      mainColor: "#9EE1FA",
    },
    "PHANTASY Pt.2": {
      img: "https://i.ibb.co/w0Bgf7h/theboyz-phantasy-pt2.png",
      albumSalesData: [36500, 86800, 188500, 283200, 377200, 490700, 600300],
      mainColor: "#414A74",
    },
    "PHANTASY Pt.3": {
      img: "https://i.ibb.co/8b6pxsL/theboyz-phantasy-pt3.png",
      albumSalesData: [243200, 295900, 317900, 339700, 360700, 360700, 403000],
      mainColor: "#FFFFFF",
    },
    導火線: {
      img: "https://i.ibb.co/Tv5ryDX/theboyz.png",
      albumSalesData: [401800, 488200, 531100, 549800, 561200, 563000, 566400],
      mainColor: "#7394AD",
    },
  },
  ZEROBASEONE: {
    "YOUTH IN THE SHADE": {
      img: "https://i.ibb.co/6NBC8P7/zb1-youth-in-the-shade.png",
      albumSalesData: [
        1240700, 1302700, 1346500, 1426500, 1526600, 1541600, 1822000,
      ],
      mainColor: "#84B7E3",
    },
    "MELTING POINT": {
      img: "https://i.ibb.co/fHCP1N8/zb1-melting-point.png",
      albumSalesData: [
        1458000, 1597100, 1668200, 1756600, 1902400, 1992300, 2131300,
      ],
      mainColor: "#F5ABAF",
    },
    "You had me at HELLO": {
      img: "https://i.ibb.co/4WcPrmX/zb1-you-had-me-at-hello.png",
      albumSalesData: [
        1008800, 1054900, 1065300, 1074600, 1177500, 1266200, 1353100,
      ],
      mainColor: "#F0AF55",
    },
    "CINEMA PARADISE": {
      img: "https://i.ibb.co/LZDv1YD/zb1-cinema-paradise.png",
      albumSalesData: [
        870200, 913500, 939200, 966900, 1012600, 1025800, 1112400,
      ],
      mainColor: "#D0EBED",
    },
    "BLUE PARADISE": {
      img: "https://i.ibb.co/8DmxqzSH/zb1-BLUE-PARADISE.png",
      albumSalesData: [
        1013900, 1022300, 1080500, 1136900, 1226900, 1229200, 1252300,
      ],
      mainColor: "#D9EBFC",
    },
  },
  RIIZE: {
    "Get A Guitar": {
      img: "https://i.ibb.co/tLsQ09C/riize-get-a-guitar.png",
      albumSalesData: [178200, 488700, 566900, 692100, 788400, 788900, 1016800],
      mainColor: "#8E3120",
    },
    RIIZING: {
      img: "https://i.ibb.co/VYYwSYT/riize-riizing.png",
      albumSalesData: [
        661700, 679700, 685500, 1002800, 1073100, 1076600, 1255000,
      ],
      mainColor: "#5293EA",
    },
    "RIIZING : Epilogue": {
      img: "https://i.ibb.co/G3LgdZQ/riize-riizing-epilogue.png",
      albumSalesData: [128000, 138600, 150700, 161500, 165900, 167200, 273600],
      mainColor: "#BD6A41 ",
    },
  },
  NCTWISH: {
    WISH: {
      img: "https://i.ibb.co/jhHwqTw/nctwish-wish.png",
      albumSalesData: [92700, 192100, 207500, 222900, 233200, 233300, 280400],
      mainColor: "#E5F400",
    },
    Songbird: {
      img: "https://i.ibb.co/VWzjhGT/nctwish-songbird.png",
      albumSalesData: [270600, 386300, 388300, 447100, 475800, 514700, 537900],
      mainColor: "#3D98DB",
    },
    Steady: {
      img: "https://i.ibb.co/xfQc1WH/nctwish-steady.png",
      albumSalesData: [213400, 321700, 337200, 618800, 621400, 625000, 792300],
      mainColor: "#E49EA3",
    },
  },
};
